import { ConditionByLevelWithNotesDetails } from "./ConditionByLevelWithNotesDetails";
import { CostByPartNumber } from "./CostByPartNumber";
import { CostReviewPlannedCosts } from "./CostReviewPlannedCosts";
import { HoursByLevel } from "./HoursByLevel";
import { LaborByLevel } from "./LaborByLevel";
import { LaborHoursDistribution } from "./LaborHoursDistribution";
import { NewCostReviewAttributesBase } from "./NewCostReviewAttributesBase";
import { SubsAndMiscCosts } from "./SubsAndMiscCosts";
import { TaskByLevelWithNotes } from "./TaskByLevelWithNotes";

    
export class NewCostReviewAttributes_SOL extends NewCostReviewAttributesBase {
  laborHoursDistributionDetails: LaborHoursDistribution[] = [];
  costByPartNumberDetails: CostByPartNumber[] = [];
  subsAndMiscCostsDetails: SubsAndMiscCosts[] = [];
  laborByLevelDetails: LaborByLevel[] = [];
  taskByLevelWithNotesDetails: TaskByLevelWithNotes[] = [];
  hoursByLevelDetails: HoursByLevel[] = [];
  costElementsZTC: CostReviewPlannedCosts[] = [];
  autoRiskDollars: number = 0;
  autoRiskPercentageOfTDC: number = 0;
  conditionByLevelWithNotesDetails: ConditionByLevelWithNotesDetails[] = [];
}
